import React from 'react'
import PageHeader from 'features/Segments/components/PageHeader'
import PageBodyContainer from 'features/Segments/components/PageBodyContainer'
import PayCadenceManagement from './components/PayCadenceManagement'

interface PayCadencePageViewProps {
  activeTab: number
  setActiveTab: (tab: number) => void
  tabs: { label: string; value: number }[]
}

const PayCadencePageView = ({
  activeTab,
  setActiveTab,
  tabs,
}: PayCadencePageViewProps) => (
  <>
    <PageHeader
      title='My Commuters'
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabs={tabs}
    />
    <PageBodyContainer>
      <PayCadenceManagement
        title='Pay schedules'
        description='Manage pay schedules for each worksite or custom group.'
      />
    </PageBodyContainer>
  </>
)

if (process.env.NODE_ENV !== 'production') {
  PayCadencePageView.displayName = 'PayCadencePageView'
}

export default React.memo(PayCadencePageView)
